"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup, useBlockExplorer } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Collapsible, Flex, FlexColumn, formatAddress, formatTokenId, IconCallout, Markdown, Separator, TextBody } from "@opensea/ui-kit";
import { AttachMoney, EditNote, GridView, NorthEast, Stat0Filled, TileMedium } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useAddress } from "@/hooks/wallet";
import { ItemAboutFragment } from "../../fragments";
export function AboutSection(t0) {
  const $ = _c(5);
  const {
    content,
    defaultOpen,
    icon,
    title
  } = t0;
  let t1;
  if ($[0] !== content || $[1] !== defaultOpen || $[2] !== icon || $[3] !== title) {
    t1 = content ? <div className="w-full rounded-lg border border-border-1 bg-bg-primary"><Collapsible className="w-full p-4 text-left" content={<div className="px-4 pb-4">{content}</div>} defaultOpen={defaultOpen}><Flex className="items-center gap-3"><IconCallout icon={icon} size={16} variant="outlined" /><TextBody color="text-primary" size="md" weight="semibold">{title}</TextBody></Flex></Collapsible></div> : null;
    $[0] = content;
    $[1] = defaultOpen;
    $[2] = icon;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function displayTokenStandard(standard, isCreatorRestricted) {
  if (!standard) {
    return null;
  }
  if (isCreatorRestricted && (standard === "ERC721" || standard === "ERC1155")) {
    return `${standard}-C`;
  }
  return standard;
}
export function ItemAbout(t0) {
  const $ = _c(36);
  const {
    activityChart,
    attributes,
    item: itemKey,
    moreItems,
    hasTraits: t1
  } = t0;
  const hasTraits = t1 === undefined ? false : t1;
  const item = readFragment(ItemAboutFragment, itemKey);
  const t = useTranslations("ItemAbout");
  const blockExplorer = useBlockExplorer(item?.chain.identifier);
  const connectedAddress = useAddress();
  let t2;
  if ($[0] !== t) {
    t2 = t("traits");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attributes || $[3] !== hasTraits || $[4] !== t2) {
    t3 = {
      content: attributes,
      icon: Stat0Filled,
      title: t2,
      defaultOpen: hasTraits
    };
    $[2] = attributes;
    $[3] = hasTraits;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("priceHistory");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activityChart || $[9] !== t4) {
    t5 = {
      content: activityChart,
      icon: AttachMoney,
      title: t4
    };
    $[8] = activityChart;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = item?.description || item?.collection?.description ? <FlexColumn className="gap-4">{item.description ? <><FlexColumn className="gap-2"><TextBody weight="semibold">{t("aboutSectionTitle", {
            name: item.name
          })}</TextBody><Markdown className="select-text text-text-secondary">{item.description}</Markdown></FlexColumn>{item.collection?.description ? <Separator /> : null}</> : null}{item.collection?.description ? <FlexColumn className="gap-2"><TextBody weight="semibold">{t("aboutSectionTitle", {
          name: item.collection.name
        })}</TextBody>{item.collection.owner ? <TextBody className="flex items-center gap-2" color="text-secondary">{t("aCollectionBy")}<AccountLockup account={item.collection.owner} connectedAddress={connectedAddress ?? null} withAvatar={true}><TextBody color="text-primary" weight="semibold">{item.collection.owner.displayName}</TextBody></AccountLockup></TextBody> : null}<Markdown className="select-text text-text-secondary">{item.collection.description}</Markdown></FlexColumn> : null}</FlexColumn> : <TextBody color="text-secondary">{t("noDescription")}</TextBody>;
  let t7;
  if ($[11] !== t) {
    t7 = t("about");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = {
      content: t6,
      icon: EditNote,
      title: t7
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = item ? <FlexColumn className="select-text gap-3"><Flex className="justify-between"><TextBody color="text-secondary">{t("contractAddress")}</TextBody><Link href={blockExplorer.getAddressUrl(item.contractAddress)}><TextBody>{formatAddress(item.contractAddress)}<NorthEast className="ml-1 inline size-4" /></TextBody></Link></Flex><Flex className="justify-between"><TextBody color="text-secondary">{t("tokenId")}</TextBody>{item.tokenUri ? <Link href={item.tokenUri}><TextBody>{formatTokenId(item.tokenId)}<NorthEast className="ml-1 inline size-4" /></TextBody></Link> : <TextBody color="text-secondary">{formatTokenId(item.tokenId)}</TextBody>}</Flex><Flex className="justify-between"><TextBody color="text-secondary">{t("tokenStandard")}</TextBody><TextBody color="text-secondary">{displayTokenStandard(item?.standard, !!item?.isCreatorTokenRestrictedContract)}</TextBody></Flex><Flex className="justify-between"><TextBody color="text-secondary">{t("chain")}</TextBody><TextBody color="text-secondary">{item.chain.name}</TextBody></Flex>{(item.details ?? []).map(_temp)}</FlexColumn> : null;
  let t10;
  if ($[16] !== t) {
    t10 = t("blockchainDetails");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = {
      content: t9,
      icon: TileMedium,
      title: t10
    };
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== moreItems) {
    t12 = <div className="-mx-4 px-4">{moreItems}</div>;
    $[21] = moreItems;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("moreFromThisCollection");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = {
      content: t12,
      icon: GridView,
      title: t13
    };
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14 || $[30] !== t3 || $[31] !== t5 || $[32] !== t8) {
    t15 = [t3, t5, t8, t11, t14];
    $[28] = t11;
    $[29] = t14;
    $[30] = t3;
    $[31] = t5;
    $[32] = t8;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const sections = t15;
  let t16;
  if ($[34] !== sections) {
    t16 = <FlexColumn className="mt-6 gap-2">{sections.map(_temp2)}</FlexColumn>;
    $[34] = sections;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}
function _temp2(section) {
  return <AboutSection key={section.title} {...section} />;
}
function _temp(t0) {
  const {
    name,
    value
  } = t0;
  return <Flex className="justify-between" key={name}><TextBody color="text-secondary">{name}</TextBody><TextBody color="text-secondary">{value}</TextBody></Flex>;
}